const LabelCount = ({
  count,
  defaultClass,
  enabledClass,
  className,
  onClickFn = null,
}) => {
  return (
    <span
      className={`${count > 0 ? enabledClass : defaultClass} ${
        onClickFn && "cursor-pointer"
      } text-xs font-mono rounded px-2 p-1 ${className}`}
      onClick={onClickFn}
    >
      {count}
    </span>
  );
};

export default LabelCount;
